import React from 'react';
import { ChevronUp, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/MobileDPad.css';

const MobileDPad = ({ onDirectionPress }) => {
  const handlePress = (direction) => {
    onDirectionPress(direction);
  };

  return (
    <div className="mobile-dpad">
      <div className="dpad-container">
        <button 
          className="dpad-button dpad-up"
          onTouchStart={() => handlePress('up')}
          onClick={() => handlePress('up')}
        >
          <ChevronUp size={24} />
        </button>
        
        <div className="dpad-middle">
          <button 
            className="dpad-button dpad-left"
            onTouchStart={() => handlePress('left')}
            onClick={() => handlePress('left')}
          >
            <ChevronLeft size={24} />
          </button>
          
          <div className="dpad-center" />
          
          <button 
            className="dpad-button dpad-right"
            onTouchStart={() => handlePress('right')}
            onClick={() => handlePress('right')}
          >
            <ChevronRight size={24} />
          </button>
        </div>
        
        <button 
          className="dpad-button dpad-down"
          onTouchStart={() => handlePress('down')}
          onClick={() => handlePress('down')}
        >
          <ChevronDown size={24} />
        </button>
      </div>
    </div>
  );
};

export default MobileDPad;
